import { Switch } from "@headlessui/react";
import { HiCheck } from "react-icons/hi2";
import { cn } from "../../lib/utils";

export type CheckboxInputProps = {
	checked: boolean;
	onChange?: (checked: boolean) => void;
	disabled?: boolean;
	partialChecked?: boolean;
	compact?: boolean;
	className?: string;
	testId?: string;
};

export const CheckboxInput = ({
	compact,
	partialChecked,
	disabled,
	className,
	checked,
	onChange,
	testId,
}: CheckboxInputProps) => {
	return (
		<Switch
			onChange={onChange}
			disabled={disabled ?? false}
			checked={checked}
			className={cn(
				"flex items-center justify-center w-[17px] min-w-[17px] h-[17px] min-h-[17px] rounded-[3px] bg-white outline outline-[1px] outline-offset-[-1px] outline-gray-600 group-hover:outline-[2px] hover:outline-[2px] shadow-sm cursor-pointer",
				compact && "w-[16px] min-w-[16px] h-[16px] min-h-[16px] rounded-[2.5px]",
				className,
				(checked || partialChecked) &&
					"bg-brand-accent outline-[0px] hover:outline-[0px] group-hover:outline-[0px]",
				disabled &&
					"bg-gray-200 outline-[1px] outline-bc-strong hover:outline-[1px] group-hover:outline-[1px] cursor-default",
			)}
			data-testid={testId}
		>
			{checked && (
				<HiCheck
					className={cn("text-[12px] text-inverse stroke-[2.25px]", disabled && "text-secondary")}
				/>
			)}
			{!checked && partialChecked && (
				<hr className={cn("w-[9px] h-[2px] bg-white", disabled && "bg-gray-500")} />
			)}
		</Switch>
	);
};
